module.exports = __webpack_public_path__ + "static/048-52f4b7ff9c12ec14e47fdae56da5f008.jpg";